import { render } from "./ChangeHistory.vue?vue&type=template&id=52a0080f"
import script from "./ChangeHistory.vue?vue&type=script&lang=js"
export * from "./ChangeHistory.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__